module.exports = __webpack_public_path__ + "img/Slide3.7ee2d288.png";